import {Team} from "@/lib/interfaces/events";
import {User} from "@/lib/interfaces/user";

export const getAuthenticatedUser = (token: string) => {
    return fetch(`${process.env.NEXT_PUBLIC_API_URL}/me`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        }
    }).then(res => res.json());
}

export const getRefreshToken = (token: string) => {
    return fetch(`${process.env.NEXT_PUBLIC_API_URL}/refresh`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        }
    }).then(res => res.json());
}

export const logout = (token: string) => {
    return fetch(`${process.env.NEXT_PUBLIC_API_URL}/logout`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        }
    }).then(res => res.json());
}

export const updateProfile = (token: string, user: User, currentPassword?: string, newPassword?: string, confirmPassword?: string) => {
    const body = {
        ...user,
        teams: user.teams.map(team => team.id),
        sports: user.sports.map(sport => sport.id),
        brands: user.brands.map(brand => brand.id),
        location: user.location.id,
        current_password: currentPassword,
        password: newPassword,
        password_confirmation: confirmPassword,
    }
    return fetch(`${process.env.NEXT_PUBLIC_API_URL}/profile`, {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(body),
    }).then(res => res.json());
}

export const resetPasswordLink = (email: string) => {
    return fetch(`${process.env.NEXT_PUBLIC_API_URL}/password/send-reset-link`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            email,
        }),
    });
}

export const resetPassword = (email: string, token: string, password: string, password_confirmation: string) => {
    return fetch(`${process.env.NEXT_PUBLIC_API_URL}/password/reset`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            email,
            token,
            password,
            password_confirmation
        }),
    });
}
export const verify = (token: string, key: string) => {
    return fetch(`${process.env.NEXT_PUBLIC_API_URL}/email/verify`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            id: key,
            hash: token,
        }),
    }).then(res => res.json());
}

export const resendVerification = (token: string) => {
    return fetch(`${process.env.NEXT_PUBLIC_API_URL}/resend-verification`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`
        },
    }).then(res => {
        if (!res.ok) {
            return res.json().then(json => {
                return Promise.reject(json);
            })
        }
        return res.json()
    });
}

